import { ComponentContainer, LayoutGrid } from "../LayoutContainers";
import OnlyText from "../OnlyText";
import { CarouselProducts } from "../Carousels/CarouselProducts";
import { __ } from "../../locales/translation";

export default function Products({ content, isLoading }) {
    return (
        <ComponentContainer classNames="products-section">
            <LayoutGrid spacingTop="8" spacingBottom="0" cols={1}>
                <OnlyText title={__("Conocé más acerca de nuestros productos")} />
            </LayoutGrid>
            <LayoutGrid classNames="carousel-products" isFullWidth>
                <CarouselProducts slides={content || null} isLoading={isLoading} spacingBottom={8} />
            </LayoutGrid>
        </ComponentContainer>
    );
}
